import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export interface ConfirmationModalProps {
    isOpen: boolean;
    onContinueClick?: () => void;
    onDismissModal: () => void;
    headerText: string;
    bodyText: string;
    cancelButtonText?: string;
    continueButtonText?: string;
    continueDangerColor?: boolean;
    cancelColor?: string;
    isContinueOutlined?: boolean;
    showSpinner?: boolean | undefined | null;
    isCancelOutlined?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
    return (
        <Modal centered isOpen={props.isOpen} autoFocus={false} toggle={props.onDismissModal}>
            <ModalHeader toggle={props.onDismissModal}>{props.headerText}</ModalHeader>

            <ModalBody>{props.bodyText}</ModalBody>
            <ModalFooter className="d-flex justify-content-right">
                <Button
                    color={props.cancelColor || 'secondary'}
                    outline={props.isCancelOutlined}
                    onClick={props.onDismissModal}
                    className="text-capitalize"
                >
                    {props.cancelButtonText ? props.cancelButtonText : 'Cancel'}
                </Button>
                <Button
                    color={props.continueDangerColor ? 'danger' : 'primary'}
                    type="button"
                    onClick={props.onContinueClick}
                    className="text-capitalize"
                    outline={props.isContinueOutlined}
                >
                    {props.showSpinner && (
                        <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
                    )}

                    {props.continueButtonText ? props.continueButtonText : 'Continue'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmationModal;
